'use client';

import { TFeaturesResponse, useFeatureFlagsStore } from '@shared/feature';

export const FeatureFlagsProvider = ({
  features,
  children,
}: {
  features: TFeaturesResponse;
  children: React.ReactNode;
}) => {
  const setFeature = useFeatureFlagsStore((state) => state.setter);
  setFeature(features);
  return <>{children}</>;
};
